import { createFileRoute } from '@tanstack/react-router';
import { AgentChatLayout } from '../components/agent-chat/AgentChatLayout';

export const Route = createFileRoute('/agent-chat')({
  component: AgentChatRoute,
});

function AgentChatRoute() {
  // No AuthGuard — ivy-chat handles its own auth via Firebase → session token exchange.
  // The ivy-chat backend returns 401 if not authenticated, prompting login from within the chat.
  return <AgentChatLayout />;
}
